import client from "./axiosConfig";

export const getFolderListById = (folderId, params = {}) => {
  const config = {
    url: `/folders/${folderId}/`,
    method: "GET",
    params,
  };
  return client(config);
};

export const uploadFile = (formData) => {
  return client({
    url: "/folders/files/",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
};

export const createFolder = (data) => {
  return client({
    url: "/folders/",
    method: "POST",
    data,
  });
};

export const deleteFile = (id) => {
  return client({
    url: `/folders/files/${id}/`,
    method: "DELETE",
  });
};

export const deleteFolder = (id) => {
  return client({
    url: `/folders/${id}/`,
    method: "DELETE",
  });
};

export const getDriveRoot = (driveType) => {
  return client({
    url: "/folders/root/",
    method: "GET",
    params: { drive: driveType },
  });
};

export const listDrive = (driveType) => {
  return client({
    url: "/folders/",
    method: "GET",
    params: { drive: driveType},
  });
}

export const addUserToFolder = (id, userIds) => {
  return client({
    url: `/folders/${id}/`,
    method: "PATCH",
    data: { allowed_users: userIds },
  });
};